import { useState } from "react";
import { Button } from "@cntrl/ui";
import { ChangePasswordModal } from "./ChangePasswordModal.js";

/**
 * The door to {@link ChangePasswordModal}, shared by both Settings shells for the same reason the dialog
 * itself is: `POST /auth/change-password` is person-scoped, so nothing here is band- or org-specific.
 *
 * It exists as its own component rather than two `useState`s because the open state is the only thing the
 * two tabs would otherwise have had to duplicate — and duplicating it is how the two surfaces came to hold
 * two different change-password forms in the first place.
 *
 * A LINK, not a button (PO, 2026-09-06). It sits under the account details rather than in a titled Password
 * section of its own: changing a password is a rare errand off the account you are reading, not a second
 * subject on the tab. `variant="link"` is still a real `<button>` — it opens a dialog, so it must not be an
 * anchor with no href, which is unreachable by keyboard and lies to a screen reader about navigating.
 */
export function ChangePasswordButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button type="button" variant="link" onClick={() => setOpen(true)}>
        Change password
      </Button>
      {open && <ChangePasswordModal onClose={() => setOpen(false)} />}
    </>
  );
}
